export default __webpack_public_path__ + "static/Magnesium_Pool_Landing_Page_for_Mineral_Swim_V3-4c884ae1f7d452d2ab0e557dabc82e44.jpg";